import { useContext } from 'react'
import { GlobalActionLoadingContext } from './globalActionLoadingContextCore'

export const useGlobalActionLoading = () => {
  const context = useContext(GlobalActionLoadingContext)
  if (!context) throw new Error('useGlobalActionLoading must be used within GlobalActionLoadingProvider')
  return context
}

export const useOptionalGlobalActionLoading = () => useContext(GlobalActionLoadingContext)
